import { func, shape, string } from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

import DatePicker from '../../generic/DatePicker';

function EndCampaignForm({ value, onChange }) {
  return (
    <div>
      <Row className="pt-3 pb-4">
        <Col sm={2}>
          <div>Provide the end date</div>
        </Col>
        <Col sm={10}>
          <DatePicker
            name="proposedEndDate"
            onChange={onChange}
            value={value.proposedEndDate}
          />
        </Col>
      </Row>
    </div>
  );
}

EndCampaignForm.propTypes = {
  onChange: func.isRequired,
  value: shape({
    proposedEndDate: string.isRequired,
  }).isRequired,
};

export default EndCampaignForm;
